module.exports = __webpack_public_path__ + "static/media/DSC_6672_HDR.906b68ad.jpg";